import english from './en-GB';
import polish from './pl-PL';

export default {
    'en-GB': english,
    'pl-PL': polish
}
